module.exports = __webpack_public_path__ + "static/media/icon_info.edcb779d.svg";